export const ro: Record<string, string> = {
  // ── Shared ────────────────────────────────────────────────────────────────
  "shared.appName": "SkillBridge",
  "shared.footer.copyright": "© {{year}} SkillBridge. Toate drepturile rezervate.",
  "shared.footer.version": "Versiunea {{version}}",
  "shared.save": "Salvează",
  "shared.cancel": "Anulează",
  "shared.close": "Închide",
  "shared.edit": "Editează",
  "shared.delete": "Șterge",
  "shared.remove": "Elimină",
  "shared.back": "Înapoi",
  "shared.view": "Vizualizează",
  "shared.manage": "Administrează",
  "shared.create": "Creează",
  "shared.add": "Adaugă",
  "shared.approve": "Aprobă",
  "shared.reject": "Respinge",
  "shared.publish": "Publică",
  "shared.withdraw": "Retrage",
  "shared.invite": "Invită",
  "shared.search": "Caută",
  "shared.saveChanges": "Salvează modificările",
  "shared.name": "Nume",
  "shared.email": "Email",
  "shared.description": "Descriere",
  "shared.status": "Status",
  "shared.type": "Tip",
  "shared.role": "Rol",
  "shared.actions": "Acțiuni",
  "shared.members": "Membri",
  "shared.location": "Locație",
  "shared.county": "Județ",
  "shared.city": "Oraș",
  "shared.website": "Website",
  "shared.date": "Dată",
  "shared.startDate": "Dată început",
  "shared.endDate": "Dată sfârșit",
  "shared.deadline": "Termen limită",
  "shared.unlimited": "Nelimitat",
  "shared.error": "Eroare",
  "shared.selectCounty": "Selectează județul",
  "shared.selectCity": "Selectează sau introdu orașul",
  "shared.cityHint": "Nu găsești orașul? Scrie-l direct.",
  "shared.verified": "Verificat",
  "shared.incomplete": "Incomplet",

  // ── Navigation ────────────────────────────────────────────────────────────
  "nav.dashboard": "Panou de bord",
  "nav.events": "Evenimente",
  "nav.myEvents": "Evenimentele mele",
  "nav.community": "Comunitate",
  "nav.checkIn": "Sosire/Plecare",
  "nav.organizations": "Organizații",
  "nav.newOrganization": "Organizație nouă",
  "nav.profileSettings": "Setări profil",
  "nav.userGuide": "Ghid utilizator",
  "nav.logout": "Deconectare",

  // ── Layout ────────────────────────────────────────────────────────────────
  "layout.profileIncomplete":
    "Profilul tău este incomplet. Te rugăm să îl completezi pentru a accesa toate funcționalitățile.",
  "layout.completeProfile": "Completează profilul",
  "layout.phoneNumberAdded":
    "Am adăugat un câmp pentru numărul de telefon în profilurile voluntarilor. Te rugăm să îl adaugi pentru a-ți menține profilul complet.",
  "layout.addPhoneNumber": "Adaugă numărul de telefon",
  "layout.prerelease":
    "Aceasta este o versiune preliminară a SkillBridge. Funcționalitățile și datele se pot modifica fără notificare prealabilă.",

  // ── i18n ─────────────────────────────────────────────────────────────────
  "i18n.switchLanguage": "Schimbă limba",

  // ── Auth ──────────────────────────────────────────────────────────────────
  "auth.signIn.title": "Bun venit înapoi",
  "auth.signIn.subtitle": "Autentifică-te pentru a accesa contul",
  "auth.signIn.submit": "Autentificare",
  "auth.signIn.submitting": "Se autentifică...",
  "auth.signIn.error": "A apărut o eroare la autentificare",
  "auth.signIn.noAccount": "Nu ai un cont?",
  "auth.signIn.createOne": "Creează unul",
  "auth.signUp.title": "Creează un cont",
  "auth.signUp.subtitle": "Alătură-te platformei și începe să faci diferența",
  "auth.signUp.submit": "Înregistrare",
  "auth.signUp.error": "A apărut o eroare. Te rugăm să încerci din nou.",
  "auth.signUp.hasAccount": "Ai deja un cont?",
  "auth.signUp.signIn": "Autentificare",
  "auth.signUp.confirmPassword": "Confirmă parola",
  "auth.signUp.confirmPasswordPlaceholder": "Confirmă parola",
  "auth.signUp.confirmPasswordRequired": "Te rugăm să confirmi parola",
  "auth.signUp.acceptTermsPrefix": "Sunt de acord cu",
  "auth.signUp.termsLink": "Termenii și Condițiile",
  "auth.signUp.acceptTermsAnd": "și",
  "auth.signUp.privacyLink": "Politica de Confidențialitate",
  "auth.logout.title": "Deconectare",
  "auth.logout.message": "Te rugăm să aștepți...",
  "auth.logout.step1": "Invalidarea sesiunii",
  "auth.logout.step2": "Ștergerea datelor locale",
  "auth.logout.step3": "Finalizarea deconectării",
  "auth.field.emailPlaceholder": "Introdu adresa de email",
  "auth.field.emailRequired": "Te rugăm să introduci un email valid",
  "auth.field.passwordPlaceholder": "Introdu parola",
  "auth.field.passwordRequired": "Te rugăm să introduci parola",
  "auth.signUp.passwordTooShort": "Parola trebuie să aibă cel puțin 12 caractere",
  "auth.field.namePlaceholder": "Introdu numele",
  "auth.field.nameRequired": "Te rugăm să introduci numele",
  "auth.field.emailLabel": "Email",
  "auth.field.passwordLabel": "Parolă",
  "auth.field.nameLabel": "Nume",
  "auth.field.phonePlaceholder": "Introdu numărul de telefon",
  "auth.field.phoneRequired": "Te rugăm să introduci numărul de telefon",
  "auth.field.phoneLabel": "Număr de telefon",

  // ── Welcome ───────────────────────────────────────────────────────────────
  "welcome.title": "Bun venit la SkillBridge",
  "welcome.subtitle":
    "Conectăm voluntari talentați cu organizații care au nevoie de expertiza lor—transformând abilitățile în impact.",
  "welcome.getStarted": "Începe",
  "welcome.signIn": "Autentificare",
  "welcome.whyUs": "De ce SkillBridge?",
  "welcome.feature1.title": "Conectează abilități cu impact",
  "welcome.feature1.description":
    "Facem legătura între voluntari talentați și organizații care au nevoie de expertiza lor pentru proiecte cu sens.",
  "welcome.feature2.title": "Găsește potrivirea perfectă",
  "welcome.feature2.description":
    "Algoritmul nostru de potrivire te conectează cu oportunități care se aliniază cu abilitățile și interesele tale.",
  "welcome.feature3.title": "Crește și contribuie",
  "welcome.feature3.description":
    "Urmărește-ți progresul, dezvoltă noi abilități și fă o diferență reală în comunitatea ta.",
  "welcome.feature4.title": "Construiește comunități",
  "welcome.feature4.description":
    "Alătură-te unei comunități vibrante de voluntari și organizații care lucrează împreună pentru o schimbare pozitivă.",
  "welcome.howItWorks": "Cum funcționează",
  "welcome.step1.title": "Creează-ți profilul",
  "welcome.step1.description":
    "Listează-ți abilitățile, disponibilitatea și interesele pentru a începe.",
  "welcome.step2.title": "Găsește oportunități",
  "welcome.step2.description": "Descoperă oportunități potrivite cu abilitățile și programul tău.",
  "welcome.step3.title": "Fă diferența",
  "welcome.step3.description":
    "Contribuie cu abilitățile tale și urmărește-ți parcursul de voluntariat.",
  "welcome.cta.title": "Gata să faci diferența?",
  "welcome.cta.subtitle":
    "Alătură-te voluntarilor care folosesc deja SkillBridge pentru a crea un impact real.",
  "welcome.cta.joinVolunteer": "Înscrie-te ca voluntar",

  // ── Dashboard ─────────────────────────────────────────────────────────────
  dashboard: "Panou de bord",
  "dashboard.welcome": "Bun venit la SkillBridge",
  "dashboard.registerOrg": "Înregistrează o organizație",
  "dashboard.registerOrgDesc": "Creează și administrează o organizație de voluntariat",
  "dashboard.myEvents": "Evenimentele mele",
  "dashboard.myEventsDesc": "Vezi toate evenimentele la care te-ai înscris",
  "dashboard.feedback": "Trimite feedback",
  "dashboard.feedbackDesc": "Spune-ne părerea ta sau raportează o problemă",
  "dashboard.registeredEvents": "Evenimente înregistrate",
  "dashboard.noRegisteredEvents": "Nu te-ai îscris la niciun eveniment.",
  "dashboard.upcomingShifts": "Ture viitoare",
  "dashboard.noUpcomingShifts": "Nu ai nicio tură atribuită momentan.",
  "dashboard.showMore": "Arată mai multe",
  "dashboard.recommendedEvents": "Recomandate pentru tine",
  "dashboard.noRecommendedEvents":
    "Nu am găsit niciun eveniment care să se potrivească cu competențele tale.",
  "dashboard.findOtherEvents": "Vezi alte evenimente",
  "dashboard.matchScore": "potrivire",
  "dashboard.noMatch": "Nicio potrivire de competențe",

  // ── Events ────────────────────────────────────────────────────────────────
  "events.status.draft": "Ciornă",
  "events.status.published": "Publicat",
  "events.status.in_progress": "În desfășurare",
  "events.status.completed": "Finalizat",
  "events.status.cancelled": "Anulat",

  "events.registrationStatus.pending": "În așteptare",
  "events.registrationStatus.approved": "Aprobat",
  "events.registrationStatus.rejected": "Respins",
  "events.registrationStatus.waitlisted": "Listă de așteptare",
  "events.registrationStatus.withdrew": "Retras",
  "events.registrationStatus.attended": "Participat",
  "events.registrationStatus.no_show": "Neprezentare",
  "events.registrationStatus.pending_parental_consent": "Acord parental în așteptare",

  "events.list.title": "Evenimente",
  "events.list.search": "Caută evenimente...",
  "events.list.filterAll": "Toate",
  "events.list.filterUpcoming": "Viitoare",
  "events.list.filterOngoing": "În desfășurare",
  "events.list.filterPast": "Trecute",
  "events.list.allCounties": "Toate județele",
  "events.list.empty": "Niciun eveniment disponibil momentan. Revino curând!",
  "events.list.viewEvent": "Vezi evenimentul",
  "events.list.deadline": "Termen:",

  // ── Community ────────────────────────────────────────────────────────────
  "community.list.title": "Comunitate",
  "community.list.search": "Caută voluntari...",
  "community.list.empty": "Niciun voluntar disponibil momentan. Revino curând!",

  "events.detail.volunteers": "voluntari",
  "events.detail.deadline": "Termen:",
  "events.detail.withdrawConfirm": "Retrage-te din acest eveniment?",
  "events.detail.unregister": "Dezînregistrare",
  "events.detail.register": "Înscrie-te ca voluntar",
  "events.detail.registerDisabledMinAge":
    "Trebuie să ai cel puțin 15 ani pentru a te înregistra la evenimente.",
  "events.detail.viewVolunteers": "Vezi voluntarii",
  "events.detail.skills": "Abilități recomandate",
  "events.detail.registeredVolunteers": "Voluntari înregistrați",
  "events.detail.teams": "Echipe",
  "events.detail.teamVolunteers": "Voluntari:",

  "events.create.title": "Creează eveniment",
  "events.create.titleLabel": "Titlu",
  "events.create.titlePlaceholder": "Titlul evenimentului",
  "events.create.coverUrl": "URL imagine copertă",
  "events.create.coverPlaceholder": "https://example.com/image.jpg",
  "events.create.descriptionPlaceholder": "Ce vor face voluntarii?",
  "events.create.locationPlaceholder": "Stradă, locație sau reper",
  "events.create.fullDay": "Toată ziua (fără oră de început/sfârșit specifică)",
  "events.create.deadlineLabel": "Termen de înregistrare",
  "events.create.deadlineInPastError": "Termenul de înregistrare nu poate fi în trecut.",
  "events.create.deadlineError":
    "Termenul de înregistrare trebuie să fie la sau înainte de data de început.",
  "events.create.maxVolunteers": "Număr maxim voluntari",
  "events.create.skills": "Abilități recomandate",
  "events.create.skillsPlaceholder": "Selectează abilități recomandate (opțional)",
  "events.create.startDateInPastError": "Data de început nu poate fi în trecut.",
  "events.create.endDateError": "Data de sfârșit trebuie să fie după data de început",
  "events.create.submit": "Creează evenimentul",
  "events.create.submitAndPublish": "Creează și publică",

  "events.manage.backToEvent": "Înapoi la eveniment",
  "events.manage.editDetails": "Editează detaliile",
  "events.manage.publishConfirm": "Publică acest eveniment?",
  "events.manage.cancelConfirm": "Anulează acest eveniment?",
  "events.manage.close": "Finalizează evenimentul",
  "events.manage.closeConfirm":
    "Marchează evenimentul ca finalizat? Toate sesiunile de pontaj deschise vor fi închise automat.",
  "events.manage.startDate": "Data început",
  "events.manage.endDate": "Data sfârșit",
  "events.manage.deadline": "Termen înregistrare",
  "events.manage.registered": "Înregistrați",
  "events.manage.maxVolunteers": "Max voluntari",
  "events.manage.registrations": "Înregistrări",
  "events.manage.teams": "Echipe",
  "events.manage.timesheet": "Pontaj",
  "events.manage.shifts": "Ture",

  "events.edit.features": "Funcționalități",
  "events.edit.eventDocumentsEnabled": "Documente eveniment & pontaj",
  "events.edit.eventDocumentsEnabledHint":
    "Permite voluntarilor să descarce contracte, Anexa nr. 1 — Fișa Postului, certificate și fișe de evaluare, și să își înregistreze orele manual.",
  "events.edit.qrTrackingEnabled": "Check-in prin cod QR",
  "events.edit.qrTrackingEnabledHint":
    "Permite voluntarilor să se înregistreze la intrare/ieșire prin cod QR, pe lângă înregistrarea manuală a orelor. Necesită activarea documentelor de eveniment.",
  "events.edit.shiftsEnabled": "Ture",
  "events.edit.shiftsEnabledHint":
    "Împarte evenimentul în ture și atribuie voluntari aprobați, manual sau automat.",

  "events.timesheet.qrCardTitle": "Cod QR de prezență",
  "events.timesheet.wholeEvent": "Tot evenimentul",
  "events.timesheet.refreshQr": "Reîmprospătează",
  "events.timesheet.refreshesIn": "Se reîmprospătează în",
  "events.timesheet.volunteer": "Voluntar",
  "events.timesheet.team": "Echipă",
  "events.timesheet.checkIn": "Sosire",
  "events.timesheet.checkOut": "Plecare",
  "events.timesheet.duration": "Durată",
  "events.timesheet.live": "Activ",
  "events.timesheet.forceOut": "Marchează plecarea",
  "events.timesheet.forceOutConfirm": "Marchezi plecarea acestui voluntar acum?",
  "events.timesheet.editEntry": "Editează intrarea de pontaj",

  "events.checkIn.title": "Sosire / plecare",
  "events.checkIn.hint":
    "Îndreaptă camera spre codul QR al evenimentului pentru a marca sosirea sau plecarea.",
  "events.checkIn.checkedIn": "Ai fost înregistrat ca sosit!",
  "events.checkIn.checkedOut": "Ai fost înregistrat ca plecat.",
  "events.checkIn.duration": "Timp înregistrat:",
  "events.checkIn.scanAgain": "Scanează din nou",
  "events.checkIn.cameraError":
    "Nu am putut accesa camera. Verifică permisiunile browserului și încearcă din nou.",
  "events.checkIn.invalidQr": "Acesta nu pare un cod valid de sosire/plecare.",
  "events.checkIn.scanError": "Nu am putut procesa scanarea. Te rugăm să încerci din nou.",

  "events.registrations.title": "Înregistrări",
  "events.registrations.volunteer": "Voluntar",
  "events.registrations.team": "Echipă",
  "events.registrations.match": "Potrivire",
  "events.registrations.status": "Status",
  "events.registrations.applied": "Aplicat",
  "events.registrations.assignTeam": "Atribuie echipă",
  "events.registrations.assignTeamDisabled":
    "Înregistrarea trebuie aprobată înainte de a atribui o echipă",
  "events.registrations.shifts": "Ture",
  "events.registrations.assignShift": "Atribuie ture",
  "events.registrations.assignShiftDisabled":
    "Înregistrarea trebuie aprobată înainte de a atribui o tură",
  "events.registrations.shiftModalTitle": "Atribuie ture pentru {{name}}",
  "events.registrations.waitlist": "Listă de așteptare",
  "events.registrations.downloadEvaluation": "Descarcă fișa de evaluare",
  "events.registrations.evaluate": "Evaluează",
  "events.registrations.continueEvaluation": "Continuă evaluarea",
  "events.registrations.viewEvaluation": "Vizualizează evaluarea",
  "events.registrations.evaluationRequired":
    "Finalizează evaluarea înainte de a descărca fișa de evaluare",
  "events.registrations.evaluationModalTitle": "Evaluează voluntarul",
  "events.registrations.evaluationLocked":
    "Această evaluare a fost finalizată și nu mai poate fi modificată.",
  "events.registrations.evaluationRating": "Calificativ",
  "events.registrations.evaluationRatingPlaceholder": "Selectează un calificativ",
  "events.registrations.evaluationComment": "Comentariu (opțional)",
  "events.registrations.evaluationCommentPlaceholder":
    "Adaugă observații suplimentare despre performanța voluntarului",
  "events.registrations.saveEvaluationDraft": "Salvează",
  "events.registrations.completeEvaluation": "Finalizează evaluarea",
  "events.registrations.verifyConsent": "Verifică acordul parental fizic",
  "events.registrations.consentVerifyConfirm":
    "Confirmă că ai primit fizic formularul de acord parental semnat de la acest voluntar.",
  "events.registrations.consentVerified": "Acord parental verificat. Înregistrare aprobată.",
  "events.registrations.consentVerifyError":
    "Nu s-a putut verifica acordul parental. Încearcă din nou.",

  "events.evaluationRating.outstanding": "Excepțional",
  "events.evaluationRating.meets_expectations": "Îndeplinește așteptările",
  "events.evaluationRating.needs_improvement": "Necesită îmbunătățire",
  "events.evaluationRating.unsatisfactory": "Nesatisfăcător",

  "events.evaluationStatus.not_started": "Neînceput",
  "events.evaluationStatus.in_progress": "În desfășurare",
  "events.evaluationStatus.done": "Finalizat",

  "events.teams.addTeam": "Adaugă echipă",
  "events.teams.addTeamDisabled":
    "Echipele nu pot fi adăugate la un eveniment anulat, finalizat sau încheiat",
  "events.teams.description": "Descriere",
  "events.teams.maxVolunteers": "Număr maxim voluntari",
  "events.teams.addMember": "Adaugă membru",
  "events.teams.deleteConfirm": "Șterge această echipă?",
  "events.teams.removeConfirm": "Elimină din echipă?",
  "events.teams.noMembers": "Niciun membru atribuit încă.",
  "events.teams.createTeam": "Creează echipă",
  "events.teams.teamName": "Numele echipei",
  "events.teams.addMemberTitle": "Adaugă membru în echipă",
  "events.teams.selectVolunteer": "Selectează un voluntar",
  "events.teams.noEligible": "Nicio înregistrare eligibilă de adăugat.",

  "events.shifts.addShift": "Adaugă tură",
  "events.shifts.addShiftDisabled":
    "Turele nu pot fi adăugate la un eveniment anulat, finalizat sau încheiat",
  "events.shifts.startTime": "Ora de început",
  "events.shifts.endTime": "Ora de sfârșit",
  "events.shifts.maxVolunteers": "Număr maxim voluntari",
  "events.shifts.assigned": "Atribuiți",
  "events.shifts.untitled": "Tură fără nume",
  "events.shifts.team": "Echipă",
  "events.shifts.allTeams": "Toate echipele",
  "events.shifts.selectTeam": "Selectează o echipă",
  "events.shifts.teamRequired":
    "Acest eveniment are echipe — selectează echipa căreia îi aparține tura.",
  "events.shifts.selectDays": "Pentru ce zi(le) este această tură?",
  "events.shifts.dayLabel": "Ziua {{index}} ({{date}})",
  "events.shifts.selectDaysRequired": "Selectează cel puțin o zi pentru această tură.",
  "events.shifts.noShifts": "Nicio tură creată încă.",
  "events.shifts.createShift": "Creează tură",
  "events.shifts.editShift": "Editează tura",
  "events.shifts.deleteConfirm":
    "Ștergi această tură? Toate atribuirile voluntarilor vor fi eliminate.",
  "events.shifts.autoDistribute": "Distribuie automat",
  "events.shifts.autoDistributeConfirm":
    "Atribui automat voluntarii aprobați la ture, pe baza disponibilității și abilităților?",

  "events.myRegistrations.title": "Evenimentele mele",
  "events.myRegistrations.upcoming": "Viitoare",
  "events.myRegistrations.past": "Trecute",
  "events.myRegistrations.emptyPast": "Nu ai participat la niciun eveniment încă.",
  "events.myRegistrations.event": "Eveniment",
  "events.myRegistrations.organization": "Organizație",
  "events.myRegistrations.withdrawConfirm": "Retrage-te din acest eveniment?",
  "events.myRegistrations.downloadContract": "Descarcă contractul",
  "events.myRegistrations.contractError": "Contractul nu a putut fi descărcat. Încearcă din nou.",
  "events.myRegistrations.contractPrefillPrompt":
    "Dorești să completezi datele personale? Nu vor fi salvate.",
  "events.myRegistrations.contractPrefillYes": "Da, completează datele",
  "events.myRegistrations.contractPrefillNo": "Nu, descarcă așa",
  "events.myRegistrations.contractPrefillModalTitle": "Date personale pentru contract",
  "events.myRegistrations.contractPrefillNote":
    "Toate câmpurile sunt opționale. Informațiile vor apărea doar în PDF și nu vor fi stocate.",
  "events.myRegistrations.contractPrefillLocality": "Localitate",
  "events.myRegistrations.contractPrefillCounty": "Județ",
  "events.myRegistrations.contractPrefillIdSeries": "Seria BI/CI",
  "events.myRegistrations.contractPrefillIdNumber": "Număr BI/CI",
  "events.myRegistrations.contractPrefillCnp": "CNP",
  "events.myRegistrations.contractPrefillDownload": "Descarcă",
  "events.myRegistrations.downloadJobDescription": "Descarcă fișa postului",
  "events.myRegistrations.jobDescriptionError":
    "Fișa postului nu a putut fi descărcată. Încearcă din nou.",
  "events.myRegistrations.downloadCertificate": "Descarcă certificatul",
  "events.myRegistrations.certificateError":
    "Certificatul nu a putut fi descărcat. Încearcă din nou.",
  "events.myRegistrations.downloadEvaluation": "Descarcă fișa de evaluare",
  "events.myRegistrations.evaluationError":
    "Fișa de evaluare nu a putut fi descărcată. Încearcă din nou.",
  "events.myRegistrations.logHours": "Înregistrează ore",
  "events.myRegistrations.logHoursTitle": "Înregistrează ore de voluntariat",
  "events.myRegistrations.logHoursCheckIn": "Check-in",
  "events.myRegistrations.logHoursCheckOut": "Check-out",
  "events.myRegistrations.logHoursSuccess":
    "Orele au fost înregistrate. Un administrator le va revizui și valida.",
  "events.myRegistrations.logHoursError": "Orele nu au putut fi înregistrate. Încearcă din nou.",
  "events.myRegistrations.logHoursInvalidRange": "Check-out-ul trebuie să fie după check-in.",
  "events.myRegistrations.downloadParentalConsent": "Descarcă formularul de acord parental",
  "events.myRegistrations.parentalConsentError":
    "Formularul de acord parental nu a putut fi descărcat. Încearcă din nou.",
  "events.myRegistrations.empty": "Nu te-ai înscris la niciun eveniment încă.",
  "events.myRegistrations.browseEvents": "Explorează evenimente",

  // ── Organizations ─────────────────────────────────────────────────────────
  "organizations.create.title": "Creează organizație",
  "organizations.create.adminNote": "Vei fi desemnat Administrator al organizației",
  "organizations.create.adminDesc":
    "În calitate de creator al acestei organizații, vei primi automat rolul de Admin, oferindu-ți control deplin asupra membrilor, evenimentelor și setărilor.",
  "organizations.create.namePlaceholder": "Numele organizației",
  "organizations.create.descriptionPlaceholder": "Cu ce se ocupă organizația ta?",
  "organizations.create.taxId": "CUI",
  "organizations.create.taxIdPlaceholder": "ex. 12345678",
  "organizations.create.contactEmail": "Email de contact",
  "organizations.create.contactEmailPlaceholder": "contact@org.ro",
  "organizations.create.websitePlaceholder": "https://...",
  "organizations.create.submit": "Creează organizația",

  "organizations.detail.email": "Email",
  "organizations.detail.website": "Website",
  "organizations.detail.phone": "Telefon",
  "organizations.detail.taxId": "CUI",
  "organizations.detail.events": "Evenimente",
  "organizations.detail.noEvents": "Niciun eveniment încă.",

  "organizations.manage.backToOrg": "Înapoi la organizație",
  "organizations.manage.title": "Administrează organizația",
  "organizations.manage.settings": "Setări",
  "organizations.manage.membersDesc": "Invită, administrează roluri și elimină membri",
  "organizations.manage.settingsDesc": "Actualizează detaliile și informațiile organizației",
  "organizations.manage.noEvents": "Niciun eveniment încă. Creează primul!",
  "organizations.manage.ongoingEvents": "Evenimente în desfășurare",
  "organizations.manage.completedEvents": "Evenimente finalizate",
  "organizations.manage.noOngoingEvents": "Niciun eveniment activ. Creează primul!",
  "organizations.manage.noCompletedEvents": "Niciun eveniment finalizat încă.",
  "organizations.manage.createEvent": "Creează eveniment",
  "organizations.manage.createEventDesc":
    "Configurează un nou eveniment pentru înregistrarea voluntarilor",
  "organizations.manage.contract": "Șablon contract",
  "organizations.manage.contractDesc":
    "Previzualizează și descarcă șablonul contractului de voluntariat",
  "organizations.manage.branding": "Identitate Legală",
  "organizations.manage.brandingDesc": "Încarcă semnătura și ștampila pentru documentele oficiale",
  "organizations.contract.description":
    "Acesta este șablonul contractului de voluntariat folosit pentru organizația ta. Descarcă-l pentru a verifica termenii pe care voluntarii îi vor vedea când generează contractul pentru un eveniment.",
  "organizations.contract.download": "Descarcă șablonul",
  "organizations.contract.loadError":
    "Încărcarea șablonului de contract a eșuat. Încearcă din nou.",
  "organizations.contract.downloadError":
    "Descărcarea șablonului de contract a eșuat. Încearcă din nou.",
  "organizations.branding.description":
    "Încarcă semnătura și ștampila oficială cu fundal transparent (PNG). Acestea sunt încorporate automat în toate PDF-urile generate (contracte, certificate, fișe de post și fișe de evaluare).",
  "organizations.branding.signature": "Semnătură",
  "organizations.branding.stamp": "Ștampilă",
  "organizations.branding.uploaded": "Încărcată",
  "organizations.branding.notUploaded": "Neîncărcată",
  "organizations.branding.upload": "Încarcă",
  "organizations.branding.remove": "Elimină",
  "organizations.branding.uploadSignatureHint":
    "PNG transparent al semnăturii reprezentantului legal.",
  "organizations.branding.uploadStampHint": "PNG transparent al ștampilei oficiale a organizației.",
  "organizations.branding.uploadError": "Încărcarea a eșuat. Încearcă din nou.",
  "organizations.branding.removeError": "Eliminarea a eșuat. Încearcă din nou.",

  "organizations.members.title": "Membri",
  "organizations.members.invite": "Invită membru",
  "organizations.members.member": "Membru",
  "organizations.members.joined": "Alăturat",
  "organizations.members.removeConfirm": "Elimină acest membru?",
  "organizations.members.inviteTitle": "Invită membru",
  "organizations.members.invitePlaceholder": "member@example.com",
  "organizations.members.minor": "Minor",

  "organizations.settings.title": "Setări organizație",
  "organizations.settings.legalRepresentativeName": "Reprezentant legal",
  "organizations.settings.legalRepresentativeNameHint":
    "Persoana autorizată să semneze în numele organizației (folosită pe contractele de voluntariat).",
  "organizations.settings.pickMyself": "Alege-te pe tine",
  "organizations.settings.nationalRegisterNumber": "Nr. Registrul Național",
  "organizations.settings.nationalRegisterNumberHint":
    "Nr. de înregistrare din Registrul Național al Persoanelor Juridice Fără Scop Patrimonial (ex. 1234/A/2020). Apare în antetul documentelor.",
  "organizations.settings.nationalRegisterNumberPlaceholder": "ex. 1234/A/2020",

  "organizations.types.ong.label": "ONG (Asociație / Fundație / Federație)",
  "organizations.types.ong.description": "Organizații non-profit înregistrate oficial.",
  "organizations.types.company.label": "Companie privată (SRL / SA / PFA)",
  "organizations.types.company.description":
    "Companii care organizează voluntariat corporativ (CSR) sau evenimente sociale.",
  "organizations.types.public_institution.label": "Instituție publică / educațională",
  "organizations.types.public_institution.description":
    "Școli, universități, muzee, primării sau alte autorități publice.",
  "organizations.types.informal_group.label": "Grup informal / Inițiativă civică",
  "organizations.types.informal_group.description":
    "Grupuri de persoane fără entitate juridică oficială.",
  "organizations.types.other.label": "Alt tip de organizație",
  "organizations.types.other.description":
    "Structuri care nu se încadrează în categoriile de mai sus.",

  "organizations.typeShort.ong": "ONG",
  "organizations.typeShort.company": "Companie",
  "organizations.typeShort.public_institution": "Instituție publică",
  "organizations.typeShort.informal_group": "Grup informal",
  "organizations.typeShort.other": "Altul",

  "organizations.roles.admin": "Administrator",
  "organizations.roles.coordinator": "Coordonator",
  "organizations.roles.member": "Membru",

  // ── Profile ───────────────────────────────────────────────────────────────
  "profile.title": "Profil",
  "profile.skills": "Abilități",
  "profile.security": "Securitate",
  "profile.privacy": "Confidențialitate",

  "profile.completion.title": "Completare profil",
  "profile.completion.subtitle": "Completează acești pași pentru a te putea înscrie la evenimente.",
  "profile.completion.dateOfBirth": "Data nașterii",
  "profile.completion.availability": "Disponibilitate săptămânală",

  "profile.details.title": "Profilul meu",
  "profile.details.subtitle":
    "Actualizează-ți detaliile și selectează disponibilitatea pentru activitățile de voluntariat.",
  "profile.details.uploadPicture": "Click pentru a încărca poza de profil",
  "profile.details.upload": "Click pentru a încărca",
  "profile.details.personalDetails": "Date personale",
  "profile.details.nameLabel": "Nume",
  "profile.details.namePlaceholder": "Introdu numele",
  "profile.details.nameRequired": "Te rugăm să introduci numele",
  "profile.details.phoneLabel": "Număr de telefon",
  "profile.details.phonePlaceholder": "Introdu numărul de telefon",
  "profile.details.phoneRequired": "Te rugăm să introduci numărul de telefon",
  "profile.details.emailLabel": "Email",
  "profile.details.emailPlaceholder": "Introdu adresa de email",
  "profile.details.emailNote": "Actualizarea emailului nu este disponibilă momentan.",
  "profile.details.imageTypeError": "Sunt permise doar imagini JPEG/JPG și PNG",
  "profile.details.dateOfBirthLabel": "Data nașterii",
  "profile.details.dateOfBirthPlaceholder": "Selectează data nașterii",
  "profile.details.dateOfBirthRequired": "Necesară pentru înscrierea la evenimente",
  "profile.details.dateOfBirthLocked":
    "Data nașterii nu poate fi modificată după ce a fost setată. Contactează suportul dacă trebuie să o actualizezi.",
  "profile.details.imageSizeError": "Dimensiunea imaginii trebuie să fie mai mică de 5MB",
  "profile.details.minorNotice":
    "Ca minor (sub 18 ani), evenimentele care necesită un contract de voluntariat îți vor plasa înregistrarea în starea 'Acord parental în așteptare'. Va trebui să aduci personal un formular de acord parental semnat pentru ca un coordonator să îl verifice la fața locului înainte ca înregistrarea să poată fi aprobată.",
  "profile.details.save": "Salvează profilul",

  "profile.security.title": "Securitate",
  "profile.security.subtitle": "Gestionează setările de securitate ale contului tău.",

  "profile.password.title": "Schimbă parola",
  "profile.password.current": "Parola curentă",
  "profile.password.currentPlaceholder": "Introdu parola curentă",
  "profile.password.new": "Parolă nouă",
  "profile.password.newPlaceholder": "Introdu parola nouă (min. 8 caractere)",
  "profile.password.minLength": "Parola trebuie să aibă cel puțin 8 caractere.",
  "profile.password.confirm": "Confirmă parola nouă",
  "profile.password.confirmPlaceholder": "Confirmă parola nouă",
  "profile.password.mismatch": "Parolele nu coincid.",
  "profile.password.submit": "Actualizează parola",
  "profile.password.success": "Parola a fost actualizată cu succes!",
  "profile.password.error": "Actualizarea parolei a eșuat. Te rugăm să încerci din nou.",

  "profile.availability.title": "Disponibilitate săptămânală",
  "profile.availability.available": "Disponibil",
  "profile.availability.startTime": "Ora de început",
  "profile.availability.endTime": "Ora de sfârșit",
  "profile.availability.to": "până la",
  "profile.availability.save": "Salvează disponibilitatea",
  "profile.availability.monday": "Luni",
  "profile.availability.tuesday": "Marți",
  "profile.availability.wednesday": "Miercuri",
  "profile.availability.thursday": "Joi",
  "profile.availability.friday": "Vineri",
  "profile.availability.saturday": "Sâmbătă",
  "profile.availability.sunday": "Duminică",
  "profile.availability.notSet":
    "Nu ți-ai setat încă disponibilitatea. Adaugă cel puțin o zi pentru ca organizațiile să știe când poți voluntaria.",

  "profile.skills.title": "Abilitățile mele",
  "profile.skills.subtitle": "Selectează abilitățile care te descriu cel mai bine ca voluntar.",
  "profile.skills.propose": "Propune o abilitate nouă",
  "profile.skills.proposeHint":
    "Nu găsești o abilitate care ți se potrivește? Sugereaz-o și echipa noastră o va analiza.",
  "profile.skills.proposeNamePlaceholder": "ex. Apicultură, Limbaj mimico-gestual...",
  "profile.skills.proposeDescriptionPlaceholder": "Descrie pe scurt această abilitate (opțional)",
  "profile.skills.proposeSubmit": "Trimite propunerea",
  "profile.skills.save": "Salvează abilitățile",
  "profile.skills.new": "Nou",
  "profile.skills.searchPlaceholder": "Caută abilități...",
  "profile.skills.noResults": "Nu am găsit abilități care să corespundă căutării.",
  "profile.skills.unsavedChanges": "Ai modificări nesalvate",

  // ── Skill categories ─────────────────────────────────────────────────────
  "skills.category.Technical": "Tehnic",
  "skills.category.Creative": "Creativ",
  "skills.category.Physical": "Fizic",
  "skills.category.Social": "Social",

  "profile.privacy.title": "Confidențialitate și date",
  "profile.privacy.subtitle": "Gestionează datele pe care SkillBridge le deține despre tine.",
  "profile.privacy.exportTitle": "Solicită-ți datele",
  "profile.privacy.exportDescription":
    "Descarcă o copie a tuturor datelor stocate despre tine, inclusiv profilul, abilitățile, apartenențele la organizații, înscrierile la evenimente, feedback-ul și notificările.",
  "profile.privacy.exportSubmit": "Descarcă-mi datele",
  "profile.privacy.exportError": "Exportul datelor a eșuat. Te rugăm să încerci din nou.",
  "profile.privacy.deleteTitle": "Șterge contul",
  "profile.privacy.deleteDescription":
    "Șterge definitiv contul tău și toate datele asociate, inclusiv organizațiile create de tine. Această acțiune nu poate fi anulată.",
  "profile.privacy.deleteSubmit": "Șterge-mi contul",
  "profile.privacy.deleteConfirm": "Ești sigur că vrei să ștergi definitiv contul?",
  "profile.privacy.deleteSuccess": "Contul tău a fost șters.",
  "profile.privacy.deleteError": "Ștergerea contului a eșuat. Te rugăm să încerci din nou.",

  // ── Feedback ──────────────────────────────────────────────────────────────
  "feedback.title": "Trimite feedback",
  "feedback.submit": "Trimite",
  "feedback.category.label": "Categorie",
  "feedback.category.suggestion": "Sugestie",
  "feedback.category.bug": "Raportare problemă",
  "feedback.category.other": "Altceva",
  "feedback.message": "Mesaj",
  "feedback.messagePlaceholder": "Spune-ne ce ai pe suflet...",

  // ── Notifications ────────────────────────────────────────────────────────
  "notifications.title": "Notificări",
  "notifications.empty": "Nu ai nicio notificare încă.",
  "notifications.markAllRead": "Marchează toate ca citite",
  "notifications.viewAll": "Vezi toate",
  "notifications.loadMore": "Încarcă mai multe",
  "notifications.deleteConfirm": "Ștergi această notificare?",
  "notifications.message.registrationApproved":
    'Înscrierea ta la "{{eventTitle}}" a fost aprobată.',
  "notifications.message.registrationRejected":
    'Înscrierea ta la "{{eventTitle}}" a fost respinsă.',
  "notifications.message.registrationWaitlisted":
    'Ai fost adăugat pe lista de așteptare pentru "{{eventTitle}}".',
  "notifications.message.teamAssigned": 'Ai fost repartizat într-o echipă pentru "{{eventTitle}}".',
  "notifications.message.teamRemoved": 'Ai fost scos din echipă pentru "{{eventTitle}}".',
  "notifications.message.eventCancelled": 'Evenimentul "{{eventTitle}}" a fost anulat.',
  "notifications.message.registrationSubmitted": 'Un nou voluntar s-a înscris la "{{eventTitle}}".',
  "notifications.message.registrationWithdrawn": 'Un voluntar s-a retras de la "{{eventTitle}}".',
  "notifications.message.evaluationCompleted":
    'Evaluarea ta pentru "{{eventTitle}}" este gata de descărcat.',
  "notifications.message.timesheetValidated":
    'Orele tale înregistrate pentru "{{eventTitle}}" au fost validate.',
  "notifications.message.timesheetRejected":
    'Orele tale înregistrate pentru "{{eventTitle}}" au fost respinse.',
  "notifications.message.manualHoursSubmitted":
    'Un voluntar a trimis ore manuale pentru "{{eventTitle}}".',
  "notifications.message.orgRoleChanged": "Rolul tău în {{orgName}} a fost schimbat în {{toRole}}.",
  "notifications.message.orgMemberRemoved": "Ai fost eliminat din {{orgName}}.",
  "notifications.message.shiftAssigned": 'Ai fost repartizat pe un tur pentru "{{eventTitle}}".',
  "notifications.message.shiftUnassigned": 'Ai fost scos de pe un tur pentru "{{eventTitle}}".',
  "notifications.message.shiftUpdated":
    'Un tur la care erai repartizat pentru "{{eventTitle}}" a fost modificat; verifică-ți turele.',
  "notifications.message.shiftCancelled":
    'Un tur la care erai repartizat pentru "{{eventTitle}}" a fost anulat.'
};
